// Mobility Brand Assets — central source of truth for logos & landing imagery.
// Local optimized assets (cropped to content, retina-ready) live in /public/brand/.

const CDN = 'https://customer-assets.emergentagent.com/job_51d2d6b5-5bf9-478f-a161-3e9a68e7786e/artifacts';

export const BRAND = {
  colors: {
    lime: '#bcef3c',
    limeDark: '#a8d92e',
    black: '#000000',
    white: '#ffffff',
  },
  // Logos — local optimized PNGs (cropped to content, no padding waste)
  logos: {
    wordmarkLight: '/brand/wordmark_light.png', // for dark backgrounds (1200×335)
    wordmarkDark: '/brand/wordmark_dark.png',   // for light backgrounds (1200×335)
    iso: '/brand/iso_light_1024.png',
    iso2: '/brand/iso_dark_1024.png',
  },
  landing: {
    worldCupBanner: `${CDN}/vsiabqjg_BANNER%20LANDING%20WORLD%20CUP.png`,
    hero: `${CDN}/sv2l6gpb_johannes-hubner-NpELykTsRl8-unsplash.jpg`,
    heroAlt: `${CDN}/07v4oq7k_roman-lopez-cGOkS_UvttU-unsplash.jpg`,
    travelerLifestyle: `${CDN}/g08fekw0_jesus-herrera-bxCAGIkEZXY-unsplash.jpg`,
    travelerAirport: `${CDN}/z9ylgwt2_stefan-lehner-fOFs1-T7Hi0-unsplash.jpg`,
  },
  cities: [
    { id: 'cdmx', name: 'Ciudad de México', slug: 'CDMX', image: `${CDN}/n9dtnzes_carlos-aguilar-oGRrpBX2ER4-unsplash.jpg` },
    { id: 'mty', name: 'Monterrey', slug: 'MTY', image: `${CDN}/7elqt1br_gabriel-tovar-GsikuTlvUCU-unsplash.jpg` },
    { id: 'gdl', name: 'Guadalajara', slug: 'GDL', image: `${CDN}/eooaptbk_obi-rF_j3F2vrNc-unsplash.jpg` },
  ],
};
